import { Header } from "../../components/header/Header";
import { Footer } from "../../components/footer/Footer";
import { Outlet } from "react-router-dom";

export function Cask() {
  return (
    <div className="App">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}
